<div class="wrapper-mini text-center auth-form">
    <h1 class="header">Verify Your Email</h1>
    <p class="margin-bottom-20">Enter the 6-digit code sent to <strong>{{ email }}</strong></p>

    <div class="form-block text-left">
        <div class="code-actions">
            <a class="pointer" data-testid="link-clear-code" (click)="clearCode()">{{ codeDigitsIsEmpty() ? '&nbsp;' : 'Clear' }}</a>
        </div>
        <div class="code-inputs text-center">
            <input #digitInput
                   class="code-input"
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   pattern="\d*"
                   data-testid="input-code-digit-0"
                   [value]="codeDigits[0]"
                   (input)="onDigitInput($event, 0)"
                   (keydown)="onDigitKeyDown($event, 0)"
                   (paste)="onDigitPaste($event, 0)"
                   (focus)="onDigitFocus($event, 0)">
            <input #digitInput
                   class="code-input"
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   pattern="\d*"
                   data-testid="input-code-digit-1"
                   [value]="codeDigits[1]"
                   (input)="onDigitInput($event, 1)"
                   (keydown)="onDigitKeyDown($event, 1)"
                   (paste)="onDigitPaste($event, 1)"
                   (focus)="onDigitFocus($event, 1)">
            <input #digitInput
                   class="code-input"
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   pattern="\d*"
                   data-testid="input-code-digit-2"
                   [value]="codeDigits[2]"
                   (input)="onDigitInput($event, 2)"
                   (keydown)="onDigitKeyDown($event, 2)"
                   (paste)="onDigitPaste($event, 2)"
                   (focus)="onDigitFocus($event, 2)">
            <input #digitInput
                   class="code-input"
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   pattern="\d*"
                   data-testid="input-code-digit-3"
                   [value]="codeDigits[3]"
                   (input)="onDigitInput($event, 3)"
                   (keydown)="onDigitKeyDown($event, 3)"
                   (paste)="onDigitPaste($event, 3)"
                   (focus)="onDigitFocus($event, 3)">
            <input #digitInput
                   class="code-input"
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   pattern="\d*"
                   data-testid="input-code-digit-4"
                   [value]="codeDigits[4]"
                   (input)="onDigitInput($event, 4)"
                   (keydown)="onDigitKeyDown($event, 4)"
                   (paste)="onDigitPaste($event, 4)"
                   (focus)="onDigitFocus($event, 4)">
            <input #digitInput
                   class="code-input"
                   type="text"
                   inputmode="numeric"
                   maxlength="1"
                   pattern="\d*"
                   data-testid="input-code-digit-5"
                   [value]="codeDigits[5]"
                   (input)="onDigitInput($event, 5)"
                   (keydown)="onDigitKeyDown($event, 5)"
                   (paste)="onDigitPaste($event, 5)"
                   (focus)="onDigitFocus($event, 5)">
        </div>
    </div>

    <!-- Resend code link directly beneath the input -->
    <p class="margin-top-10">
        <a class="text-color-primary pointer" data-testid="link-resend-code" (click)="resendCode()">
            {{ resendingCode ? 'Resending…' : 'Resend verification code' }}
        </a>
    </p>

    <div class="footer">
        <saffron-button #verifyBtn text="Verify Code"
                        data-testid="btn-verify-code"
                        size="wide" 
                        type="primary" 
                        [is_loading]="loading"
                        [is_disabled]="!isCodeComplete()"
                        (click)="verifyCode()">
        </saffron-button>
        <p>
            <a class="text-color-primary pointer" data-testid="link-back-to-email" (click)="goBack()">Back</a>
        </p>
    </div>
</div>
